<template>
  <card shadow>
    <template #header>
      <div class="bg-white border-0">
        <div class="row align-items-center">
          <div class="col-md-4 text-start">
            <h5 class="mb-0">{{ $t("Request Details") }}</h5>
          </div>
          <div class="col-md-8 text-end">
            <action-buttons :request-data="requestData" @get-request="getRequest"></action-buttons>
          </div>
        </div>
      </div>
    </template>


<!--      <div class="fw-bolder text-uppercase text-muted mt-4 text-start">Details</div>-->
<!--      <hr class="m-0">-->
      <div class="pl-lg-4 text-start">
        <div class="row">
          <div v-if="!isShift" class="col-md-12">
            <div v-if="userRole === 'client'" class="alert alert-warning" role="alert">
              {{ $t("Any consumables will not be provided by the healthcare professional. This can be arranged after consultation with the professional.") }}
            </div>
            <div v-if="userRole === 'employee'" class="alert alert-warning" role="alert">
              {{ $t("Please contact the customer in advance for further clarification.") }}
            </div>
          </div>
        </div>
        <div class="row">
          <div v-if="isShift" class="col-md-3">
             <display-label
                label="Request time:"
               :value="requestData.hasOwnProperty('mStartDate') && requestData.hasOwnProperty('mEndDate') ? requestData.mStartDate.format('dddd, DD MMM YYYY HH:mm') + requestData.mEndDate.format(' - HH:mm') : ''"
              ></display-label>
          </div>
          <div v-else class="col-md-3">
             <display-label
                label="Client preferable time"
               :value="requestData.hasOwnProperty('mStartDate') && requestData.hasOwnProperty('mEndDate') ? requestData.mStartDate.format('dddd, DD MMM YYYY') + ' <br> '+ requestData.mStartDate.format('HH:mm') + requestData.mEndDate.format(' - HH:mm') : ''"
              ></display-label>
          </div>
          <div class="col-md-3 pt-md-2">
            <label class="form-label fw-bold m-0">{{ $t("Status") }}:</label> <br>
            <div class="badge p-1 font-size-sm" :class="getStatusClass(requestData.status)">
              <span class="status">{{ $t(requestData.status ?? "") }}</span>
            </div>
          </div>
          <div class="col-md-3">
            <display-label
                :label="$t('Type:')"
                :value="$t(requestData.serviceType ?? '')"
            ></display-label>
          </div>

          <div class="col-md-3">
            <display-label
                :label="$t('City:')"
                :value="$t(requestData.city ?? '')"
            ></display-label>
          </div>

          <div v-if="showExtraInfo || userRole === 'system'" class="col-md-3 pt-md-2">
            <div class="form-group has-label">
              <label class="form-label fw-bold m-0">{{ $t("Client") }}:</label><br>
              <router-link v-if="userRole === 'client'" class="pb-2" to="/account/info">{{ requestData.clientName }}</router-link>
              <router-link v-if="userRole === 'system'" class="pb-2" :to="`/clients/${requestData.clientId}`">{{ requestData.clientName }}</router-link>
              <div v-else class="pb-2">{{ requestData.clientName }}</div>
            </div>
          </div>
          <div v-if="requestData.buyerId != null && userRole !== 'employee'" class="col-md-3">
            <label class="form-label fw-bold m-0">{{ $t("Employee") }}:</label> <br>
            <a v-if="userRole === 'system'" :href="'/employees/'+requestData.buyerId">{{ requestData.buyerName }}</a>
            <span v-else>{{ requestData.buyerName }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 pt-md-2">
            <display-label
                :label="$t('Preferred payment method:')"
                :value="$t(requestData.preferredPaymentMethod ?? '')"
            ></display-label>
          </div>
          <div class="col-md-3 pt-md-2">
            <display-label
                :label="$t('Preferred gender:')"
                :value="$t(requestData.gender ?? 'No preference')"
            ></display-label>
          </div>
          <div v-if="requestData.status === 'CANCELED' && requestData.cancellationReason != null" class="col-md-3 pt-md-2">
            <display-label
                :label="$t('Cancellation Reason:')"
                :value="requestData.cancellationReason"
            ></display-label>
          </div>
          <div class="col-md-3 pt-md-2">
            <display-label
                :label="$t('Created at:')"
                :value="requestData.createdAt"
            ></display-label>
          </div>
        </div>
        <div class="row">
          <display-label
              :label="$t('Notes:')"
              :value="requestData.notes ?? '-'"
          ></display-label>
        </div>
        <div class="row">
<!--          <div v-if="requestData.hasOwnProperty('updatedAt')" class="col-md-6 pt-md-2">-->
<!--            <display-label-->
<!--                label="Updated at:"-->
<!--                :value="requestData.updatedAt"-->
<!--            ></display-label>-->
<!--          </div>-->
      </div>
      </div>


<!--      <div class="fw-bolder text-uppercase text-muted mt-4 text-start">Contact Details</div>-->
<!--      <hr class="m-0">-->
  </card>
</template>
<script>
import DisplayLabel from "@/components/DisplayLabel"
import {getStatusClass} from "@/helpers/common"
import ActionButtons from "@/views/Requests/ActionButtons"
export default {
  name: "request-details-card",
  components: {ActionButtons, DisplayLabel},
  props: {
    requestData: {
      type: Object,
      description: "Client data",
    },
  },
  emits: ["getRequest"],
  data() {
    return {
      today: new Date(),
      isDisabled: true,
      alertMessage: "",
      loadingProcess: "",
      model: {
        requestStatus: null,
        clientId: null,
        deadline: null,
        startDate: null,
        endDate: null,
        cost: {
          totalCost: null,
          employeeEarnings: null,
          companyCommission: null,
        }
      }
    }
  },
  computed: {
    showExtraInfo(){
      return this.requestData.buyerId === this.$store.state.user.claims.user_id && this.requestData.status === "purchased"
    },
    userRole(){
      return this.$store.state.user?.claims?.role ?? null
    },
    isShift(){
        return this.requestData.serviceType === "shift" ?? false
    }
  },
  watch: {
    requestData(newVal) {
      console.log("newVal", newVal)
      this.model = newVal
    },
  },
  mounted() {
    // var self = this;
    console.log(this.$route.params)
    console.log("requestData card", this.requestData)
    // this.mapCompany();
  },
  methods: {
    getStatusClass,
    getRequest(){
      this.$emit("getRequest")
    },
    getValueOrDefault(obj, prop, defaultValue){
      return Object.prototype.hasOwnProperty.call(obj, prop) ? (obj[prop] || defaultValue) : defaultValue
    }

  },
}
</script>
<style></style>
